import { IAppState, IAppConfig  } from '../../store';
import { Component, OnInit } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import {SiteURL, SiteURLUtils} from '../../common/site.url.utils';

@Component({
    selector: 'stay-mgmt-redirector',
    template: ``,
})
export class RedirectorComponent implements OnInit {

    state: IAppState;
    appConfig: IAppConfig;

    constructor( private ngRedux: NgRedux<IAppState>
    ) { }

    ngOnInit() {
        this.state = this.ngRedux.getState();
        this.appConfig = this.state.appConfig;

        SiteURLUtils.redirectToSiteUrl(this.appConfig, SiteURL.HOMEPAGE_ERROR);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/redirector/redirector.component.ts